import RestaurantPage, { RestaurantProps } from '@app/pages/Restaurant';
import { APICliqueiAchei } from '@app/services/cliqueiachei-api';
import { APICAPedidos } from '@app/services/cliqueiachei-pedidos-api';
import { CliqueiAcheiData, Menu, MenuItem, MenuTypes, PageModels, Restaurant } from '@app/types';
import { adaptCliqueiAcheiClientResponseDataTo } from '@app/utils/adapters';
import { GetServerSideProps, GetStaticPaths, GetStaticProps, GetStaticPropsResult } from 'next';

import cliqueiAcheiDataMocked from '@app/__tests__/_data/cliqueiachei-data.json';
import restaurantDataMocked from '@app/__tests__/_data/restaurant-data.json';
import BagContextProvider from '@app/contexts/Bag';
import { MenuItemFactory } from '@app/utils/menu';
import { MenuItemWithDetails } from '@app/types/menu-item';

type Params = {
  params: string[];
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<RestaurantProps, Params> = async (context) => {
  console.log('Timezone Offset:', new Date().getTimezoneOffset());
  const params = context.params?.params as string[];

  console.log('Parameters Received: ', context.params?.params);

  if (hasBagOnParamsButDontHaveProduct()) return dispatchNotFoundStatus();

  let shouldAddInitialProductToBag = false;
  if (hasBagOnParams()) {
    shouldAddInitialProductToBag = true;
    params.shift();
  }

  const [localPath, cliqueiAcheiIdOrDomain, productPath, productId] = params;

  if (localPath !== 'local') return dispatchNotFoundStatus();

  const isAInternalMenu = Number(cliqueiAcheiIdOrDomain) < 0;

  if (isToMockData()) return mockedData();

  try {
    console.log('Fetching menu data...');
    const response = await APICAPedidos.fetchRestaurantData(cliqueiAcheiIdOrDomain);
    const restaurant = response.data.data;

    if (!restaurant) return dispatchNotFoundStatus();

    console.log('Fetching Cliquei Achei page data...');
    const { data: cliqueiAcheiClient } = await APICliqueiAchei.fetchClientDataById(restaurant.cliqueiAcheiId);
    const cliqueiAcheiPedidosClient = adaptCliqueiAcheiClientResponseDataTo(cliqueiAcheiClient);

    console.log('Data fetched successfully!');

    let item = null;
    if (productPath && productId) {
      if (productPath !== 'produto') return dispatchNotFoundStatus();

      item = findMenuItem(restaurant.menus, productId);
      if (!item) return dispatchNotFoundStatus();
    }

    const isLead = Boolean(
      cliqueiAcheiPedidosClient.Completo === false || !isDeliveryPageModel(cliqueiAcheiPedidosClient)
    );

    return {
      props: {
        restaurant,
        cliqueiAcheiData: cliqueiAcheiPedidosClient,
        initialProduct: item,
        shouldAddInitialProductToBag,
        isLead: isLead,
        isAInternalMenu: isAInternalMenu,
      },
      revalidate: 1,
    };
  } catch (error: any) {
    console.log('Ocorreu um erro: ', error.message);
    return {
      props: {
        errorCode: 500,
        isAInternalMenu,
      },
      revalidate: 1,
    };
  }

  function findMenuItem(menus: Menu[], menuItemIdToFind: string): MenuItemWithDetails | null {
    for (const menu of menus) {
      for (const item of menu.itens) {
        if (item.id === menuItemIdToFind) {
          return MenuItemFactory.createMenuItemWithDetails({ menuItem: item, menu });
        }
      }
    }
    return null;
  }

  function isDeliveryPageModel(data: CliqueiAcheiData) {
    const pages = [PageModels.CardapioBarriga, PageModels.Pedidos, PageModels.PedidosWhatsapp];
    return pages.includes(data.ModeloPaginaId);
  }

  function hasBagOnParamsButDontHaveProduct() {
    return params[0] === 'sacola' && !params[3];
  }

  function hasBagOnParams() {
    return params[0] === 'sacola';
  }

  function dispatchNotFoundStatus(): GetStaticPropsResult<RestaurantProps> {
    return { notFound: true, revalidate: 1 };
  }

  function isToMockData() {
    return params[params.length - 1] === 'test' && process.env.NODE_ENV === 'development';
  }

  function mockedData(): GetStaticPropsResult<RestaurantProps> {
    return {
      props: {
        isAInternalMenu,
        cliqueiAcheiData: cliqueiAcheiDataMocked,
        restaurant: restaurantDataMocked as Restaurant,
      },
    };
  }
};

// export const getServerSideProps: GetServerSideProps<RestaurantProps, Params> = async (context) => {
//   const params = context.params?.params as string[];

//   console.log('Parâmetros recebidos: ', context.params?.params);

//   if (hasBagOnParamsButDontHaveProduct()) return dispatchNotFoundStatus();

//   let shouldAddInitialProductToBag = false;
//   if (hasBagOnParams()) {
//     shouldAddInitialProductToBag = true;
//     params.shift();
//   }

//   const [localPath, cliqueiAcheiId, productPath, productId] = params;

//   if (localPath !== 'local') return dispatchNotFoundStatus();

//   try {
//     console.log('Buscando dados do cardápio...');
//     const response = await APICAPedidos.fetchRestaurantData(cliqueiAcheiId);
//     const restaurant = response.data.data;

//     if (!restaurant) return dispatchNotFoundStatus();

//     console.log('Buscando dados da página do Cliquei Achei...');
//     const { data: cliqueiAcheiClient } = await APICliqueiAchei.fetchClientDataById(cliqueiAcheiId);
//     const cliqueiAcheiPedidosClient = adaptCliqueiAcheiClientResponseDataTo(cliqueiAcheiClient);

//     console.log('Dados buscado com sucesso!');

//     let item = null;
//     if (productPath && productId) {
//       if (productPath !== 'produto') return dispatchNotFoundStatus();

//       item = findMenuItem(restaurant.menus, productId);
//       if (!item) return dispatchNotFoundStatus();
//     }

//     return {
//       props: {
//         restaurant,
//         cliqueiAcheiData: cliqueiAcheiPedidosClient,
//         initialProduct: item,
//         shouldAddInitialProductToBag,
//       },
//     };
//   } catch (error) {
//     console.log('Ocorreu um erro: ', error.message);
//     return {
//       props: {
//         errorCode: 500,
//       },
//     };
//   }

//   function findMenuItem(menus: Menu[], menuItemIdToFind: string): MenuItem | null {
//     for (const menu of menus) {
//       for (const item of menu.itens) {
//         if (item.id === menuItemIdToFind) {
//           const itemCopy = createMenuItemToUseInDetailsModal(item, {
//             isPizzaItem: menu.tipoMenu === MenuTypes.Pizza,
//             parentMenuName: menu.nome,
//           });
//           return itemCopy;
//         }
//       }
//     }
//     return null;
//   }

//   function hasBagOnParamsButDontHaveProduct() {
//     return params[0] === 'sacola' && !params[3];
//   }

//   function hasBagOnParams() {
//     return params[0] === 'sacola';
//   }

//   function dispatchNotFoundStatus(): GetServerSidePropsResult<RestaurantProps> {
//     return { notFound: true };
//   }
// };

export default function RestaurantPageRoute(props: RestaurantProps) {
  return (
    <BagContextProvider cliqueiAcheiId={String(props.cliqueiAcheiData?.Cod_Cliente ?? '')}>
      <RestaurantPage {...props} />
    </BagContextProvider>
  );
}
